import './assets/main.css';var _ = Object.defineProperty;
var A = Object.getOwnPropertySymbols;
var O = Object.prototype.hasOwnProperty, G = Object.prototype.propertyIsEnumerable;
var D = (r, l, a) => l in r ? _(r, l, { enumerable: !0, configurable: !0, writable: !0, value: a }) : r[l] = a, y = (r, l) => {
  for (var a in l || (l = {}))
    O.call(l, a) && D(r, a, l[a]);
  if (A)
    for (var a of A(l))
      G.call(l, a) && D(r, a, l[a]);
  return r;
};
import { Alert as Ar } from "./components/Alert/index.js";
import { Avatar as kr } from "./components/Avatar/index.js";
import { B as Sr } from "./index-BYV88PwO.js";
import { Breadcrumbs as Tr } from "./components/Breadcrumbs/index.js";
import { Button as Pr } from "./components/Button/index.js";
import { Card as Lr } from "./components/Card/index.js";
import { Checkbox as zr } from "./components/Checkbox/index.js";
import { Collapse as Rr } from "./components/Collapse/index.js";
import { ColorPicker as Hr } from "./components/ColorPicker/index.js";
import { DatePicker as _r } from "./components/DatePicker/index.js";
import { Dialog as Gr } from "./components/Dialog/index.js";
import { Divider as Ur } from "./components/Divider/index.js";
import { DismissibleTag as Kr } from "./components/DismissibleTag/index.js";
import { DraggableList as Xr } from "./components/DraggableList/index.js";
import { Drawer as Zr } from "./components/Drawer/index.js";
import { FileDropzone as oo } from "./components/FileDropzone/index.js";
import { Highlight as ao } from "./components/Highlight/index.js";
import { Label as io } from "./components/Label/index.js";
import { Link as eo } from "./components/Link/index.js";
import { Menu as co } from "./components/Menu/index.js";
import { Modal as uo } from "./components/Modal/index.js";
import { MultiSelect as go } from "./components/MultiSelect/index.js";
import { Notification as xo } from "./components/Notification/index.js";
import { Pagination as Fo } from "./components/Pagination/index.js";
import { ProgressIndicator as $o } from "./components/ProgressIndicator/index.js";
import { Radio as Eo } from "./components/Radio/index.js";
import { RichText as wo } from "./components/RichText/index.js";
import { SearchBar as Do } from "./components/SearchBar/index.js";
import { SegmentedControl as Bo } from "./components/SegmentedControl/index.js";
import { Slider as Mo } from "./components/Slider/index.js";
import { Select as Vo } from "./components/Select/index.js";
import { SelectableTag as ho } from "./components/SelectableTag/index.js";
import { Skeleton as jo } from "./components/Skeleton/index.js";
import { Stepper as Io } from "./components/Stepper/index.js";
import { Switch as Wo } from "./components/Switch/index.js";
import { Table as No } from "./components/Table/index.js";
import { Tabs as Oo } from "./components/Tabs/index.js";
import { TextField as qo } from "./components/TextField/index.js";
import { Tile as Jo } from "./components/Tile/index.js";
import { Title as Qo } from "./components/Title/index.js";
import { Timeline as Yo } from "./components/Timeline/index.js";
import { TimePicker as rl } from "./components/TimePicker/index.js";
import { Toggletip as ll } from "./components/Toggletip/index.js";
import { T as nl } from "./index-DQlXZnz5.js";
import { TagsInput as sl } from "./components/TagsInput/index.js";
import { InlineSelect as tl } from "./components/InlineSelect/index.js";
import { PageNavigation as pl } from "./molecules/PageNavigation/index.js";
import { ErrorMessage as ml } from "./molecules/ErrorMessage/index.js";
import { SearchPopdown as gl } from "./molecules/SearchPopdown/index.js";
import { Sidebar as xl } from "./molecules/Sidebar/index.js";
import { TopNav as Fl } from "./molecules/TopNav/index.js";
import { HeadingActions as $l } from "./molecules/HeadingActions/index.js";
import { ActionBar as El } from "./molecules/ActionBar/index.js";
import { Text as wl } from "./components/Text/index.js";
import { Flex as Dl } from "./components/Flex/index.js";
import { Group as Bl } from "./components/Group/index.js";
import { Stack as Ml } from "./components/Stack/index.js";
import { Grid as Vl } from "./components/Grid/index.js";
import { e as k, r as c } from "./rem-CMQJ_ZTp.js";
import { jsx as F, jsxs as q } from "react/jsx-runtime";
import { b as V, x as P, o as u, g as w, y as g, z as U, D as J, A as K, M as Q, C as X } from "./factory-ueRxoNOV.js";
import { p as Y } from "./get-base-value-DBR0fUhH.js";
import { useRef as Z, useState as rr, useCallback as B, useEffect as S } from "react";
import { a as M } from "./get-contrast-color-SC35uhiM.js";
import { u as h } from "./use-isomorphic-effect-CiIycTKV.js";
function T(r) {
  return r === "auto" || r === "dark" || r === "light";
}
function or({
  key: r = "mantine-color-scheme-value"
} = {}) {
  let l;
  return {
    get: (a) => {
      if (typeof window == "undefined")
        return a;
      try {
        const o = window.localStorage.getItem(r);
        return T(o) ? o : a;
      } catch (o) {
        return a;
      }
    },
    set: (a) => {
      try {
        window.localStorage.setItem(r, a);
      } catch (o) {
        console.warn(
          "[@mantine/core] Local storage color scheme manager was unable to save color scheme.",
          o
        );
      }
    },
    subscribe: (a) => {
      l = (o) => {
        o.storageArea === window.localStorage && o.key === r && T(o.newValue) && a(o.newValue);
      }, window.addEventListener("storage", l);
    },
    unsubscribe: () => {
      window.removeEventListener("storage", l);
    },
    clear: () => {
      window.localStorage.removeItem(r);
    }
  };
}
function lr() {
  const r = V(), l = P(), a = u(r.breakpoints).reduce((o, i) => {
    const n = r.breakpoints[i].includes("px"), s = Y(r.breakpoints[i]), e = n ? `${s - 0.1}px` : k(s - 0.1), t = n ? `${s}px` : k(s);
    return `${o}@media (max-width: ${e}) {.mantine-visible-from-${i} {display: none !important;}}@media (min-width: ${t}) {.mantine-hidden-from-${i} {display: none !important;}}`;
  }, "");
  return /* @__PURE__ */ F(
    "style",
    {
      "data-mantine-styles": "classes",
      nonce: l == null ? void 0 : l(),
      dangerouslySetInnerHTML: { __html: a }
    }
  );
}
function E(r) {
  return Object.entries(r).map(([l, a]) => `${l}: ${a};`).join("");
}
function b(r, l) {
  return (Array.isArray(r) ? r : [r]).reduce((o, i) => `${i}{${o}}`, l);
}
function ar(r, l) {
  const a = E(r.variables), o = a ? b(l, a) : "", i = E(r.dark), n = E(r.light), s = i ? b(l === ":host" ? `${l}([data-mantine-color-scheme="dark"])` : `${l}[data-mantine-color-scheme="dark"]`, i) : "", e = n ? b(l === ":host" ? `${l}([data-mantine-color-scheme="light"])` : `${l}[data-mantine-color-scheme="light"]`, n) : "";
  return `${o}${s}${e}`;
}
function v({
  theme: r,
  color: l,
  colorScheme: a,
  name: o = l,
  withColorValues: i = !0
}) {
  if (!r.colors[l])
    return {};
  if (a === "light") {
    const e = w(r, "light"), t = {
      [`--mantine-color-${o}-text`]: `var(--mantine-color-${o}-filled)`,
      [`--mantine-color-${o}-filled`]: `var(--mantine-color-${o}-${e})`,
      [`--mantine-color-${o}-filled-hover`]: `var(--mantine-color-${o}-${e === 9 ? 8 : e + 1})`,
      [`--mantine-color-${o}-light`]: g(r.colors[l][e], 0.1),
      [`--mantine-color-${o}-light-hover`]: g(r.colors[l][e], 0.12),
      [`--mantine-color-${o}-light-color`]: `var(--mantine-color-${o}-${e})`,
      [`--mantine-color-${o}-outline`]: `var(--mantine-color-${o}-${e})`,
      [`--mantine-color-${o}-outline-hover`]: g(r.colors[l][e], 0.05)
    };
    return i ? y({
      [`--mantine-color-${o}-0`]: r.colors[l][0],
      [`--mantine-color-${o}-1`]: r.colors[l][1],
      [`--mantine-color-${o}-2`]: r.colors[l][2],
      [`--mantine-color-${o}-3`]: r.colors[l][3],
      [`--mantine-color-${o}-4`]: r.colors[l][4],
      [`--mantine-color-${o}-5`]: r.colors[l][5],
      [`--mantine-color-${o}-6`]: r.colors[l][6],
      [`--mantine-color-${o}-7`]: r.colors[l][7],
      [`--mantine-color-${o}-8`]: r.colors[l][8],
      [`--mantine-color-${o}-9`]: r.colors[l][9]
    }, t) : t;
  }
  const n = w(r, "dark"), s = {
    [`--mantine-color-${o}-text`]: `var(--mantine-color-${o}-4)`,
    [`--mantine-color-${o}-filled`]: `var(--mantine-color-${o}-${n})`,
    [`--mantine-color-${o}-filled-hover`]: `var(--mantine-color-${o}-${n === 9 ? 8 : n + 1})`,
    [`--mantine-color-${o}-light`]: g(
      r.colors[l][Math.max(0, n - 2)],
      0.15
    ),
    [`--mantine-color-${o}-light-hover`]: g(
      r.colors[l][Math.max(0, n - 2)],
      0.2
    ),
    [`--mantine-color-${o}-light-color`]: `var(--mantine-color-${o}-${Math.max(n - 5, 0)})`,
    [`--mantine-color-${o}-outline`]: `var(--mantine-color-${o}-${Math.max(n - 4, 0)})`,
    [`--mantine-color-${o}-outline-hover`]: g(
      r.colors[l][Math.max(n - 4, 0)],
      0.05
    )
  };
  return i ? y({
    [`--mantine-color-${o}-0`]: r.colors[l][0],
    [`--mantine-color-${o}-1`]: r.colors[l][1],
    [`--mantine-color-${o}-2`]: r.colors[l][2],
    [`--mantine-color-${o}-3`]: r.colors[l][3],
    [`--mantine-color-${o}-4`]: r.colors[l][4],
    [`--mantine-color-${o}-5`]: r.colors[l][5],
    [`--mantine-color-${o}-6`]: r.colors[l][6],
    [`--mantine-color-${o}-7`]: r.colors[l][7],
    [`--mantine-color-${o}-8`]: r.colors[l][8],
    [`--mantine-color-${o}-9`]: r.colors[l][9]
  }, s) : s;
}
function nr(r) {
  return !!r && typeof r == "object" && "mantine-virtual-color" in r;
}
function f(r, l, a) {
  u(l).forEach(
    (o) => Object.assign(r, { [`--mantine-${a}-${o}`]: l[o] })
  );
}
const L = (r) => {
  const l = w(r, "light"), a = r.defaultRadius in r.radius ? r.radius[r.defaultRadius] : c(r.defaultRadius), o = {
    variables: {
      "--mantine-scale": r.scale.toString(),
      "--mantine-cursor-type": r.cursorType,
      "--mantine-color-scheme": "light dark",
      "--mantine-webkit-font-smoothing": r.fontSmoothing ? "antialiased" : "unset",
      "--mantine-moz-font-smoothing": r.fontSmoothing ? "grayscale" : "unset",
      "--mantine-color-white": r.white,
      "--mantine-color-black": r.black,
      "--mantine-line-height": r.lineHeights.md,
      "--mantine-font-family": r.fontFamily,
      "--mantine-font-family-monospace": r.fontFamilyMonospace,
      "--mantine-font-family-headings": r.headings.fontFamily,
      "--mantine-heading-font-weight": r.headings.fontWeight,
      "--mantine-heading-text-wrap": r.headings.textWrap,
      "--mantine-radius-default": a,
      // Primary colors
      "--mantine-primary-color-filled": `var(--mantine-color-${r.primaryColor}-filled)`,
      "--mantine-primary-color-filled-hover": `var(--mantine-color-${r.primaryColor}-filled-hover)`,
      "--mantine-primary-color-light": `var(--mantine-color-${r.primaryColor}-light)`,
      "--mantine-primary-color-light-hover": `var(--mantine-color-${r.primaryColor}-light-hover)`,
      "--mantine-primary-color-light-color": `var(--mantine-color-${r.primaryColor}-light-color)`
    },
    light: {
      "--mantine-primary-color-contrast": M(r, "light"),
      "--mantine-color-bright": "var(--mantine-color-black)",
      "--mantine-color-text": r.black,
      "--mantine-color-body": r.white,
      "--mantine-color-error": "var(--mantine-color-red-6)",
      "--mantine-color-placeholder": "var(--mantine-color-gray-5)",
      "--mantine-color-anchor": `var(--mantine-color-${r.primaryColor}-${l})`,
      "--mantine-color-default": "var(--mantine-color-white)",
      "--mantine-color-default-hover": "var(--mantine-color-gray-0)",
      "--mantine-color-default-color": "var(--mantine-color-black)",
      "--mantine-color-default-border": "var(--mantine-color-gray-4)",
      "--mantine-color-dimmed": "var(--mantine-color-gray-6)"
    },
    dark: {
      "--mantine-primary-color-contrast": M(r, "dark"),
      "--mantine-color-bright": "var(--mantine-color-white)",
      "--mantine-color-text": "var(--mantine-color-dark-0)",
      "--mantine-color-body": "var(--mantine-color-dark-7)",
      "--mantine-color-error": "var(--mantine-color-red-8)",
      "--mantine-color-placeholder": "var(--mantine-color-dark-3)",
      "--mantine-color-anchor": `var(--mantine-color-${r.primaryColor}-4)`,
      "--mantine-color-default": "var(--mantine-color-dark-6)",
      "--mantine-color-default-hover": "var(--mantine-color-dark-5)",
      "--mantine-color-default-color": "var(--mantine-color-white)",
      "--mantine-color-default-border": "var(--mantine-color-dark-4)",
      "--mantine-color-dimmed": "var(--mantine-color-dark-2)"
    }
  };
  f(o.variables, r.breakpoints, "breakpoint"), f(o.variables, r.spacing, "spacing"), f(o.variables, r.fontSizes, "font-size"), f(o.variables, r.lineHeights, "line-height"), f(o.variables, r.shadows, "shadow"), f(o.variables, r.radius, "radius"), r.colors[r.primaryColor].forEach((n, s) => {
    o.variables[`--mantine-primary-color-${s}`] = `var(--mantine-color-${r.primaryColor}-${s})`;
  }), u(r.colors).forEach((n) => {
    const s = r.colors[n];
    if (nr(s)) {
      Object.assign(
        o.light,
        v({
          theme: r,
          name: s.name,
          color: s.light,
          colorScheme: "light",
          withColorValues: !0
        })
      ), Object.assign(
        o.dark,
        v({
          theme: r,
          name: s.name,
          color: s.dark,
          colorScheme: "dark",
          withColorValues: !0
        })
      );
      return;
    }
    s.forEach((e, t) => {
      o.variables[`--mantine-color-${n}-${t}`] = e;
    }), Object.assign(
      o.light,
      v({
        theme: r,
        color: n,
        colorScheme: "light",
        withColorValues: !1
      })
    ), Object.assign(
      o.dark,
      v({
        theme: r,
        color: n,
        colorScheme: "dark",
        withColorValues: !1
      })
    );
  });
  const i = r.headings.sizes;
  return u(i).forEach((n) => {
    o.variables[`--mantine-${n}-font-size`] = i[n].fontSize, o.variables[`--mantine-${n}-line-height`] = i[n].lineHeight, o.variables[`--mantine-${n}-font-weight`] = i[n].fontWeight || r.headings.fontWeight;
  }), o;
};
function ir({ theme: r, generator: l }) {
  const a = L(r), o = l == null ? void 0 : l(r);
  return o ? U(a, o) : a;
}
const C = L(J);
function sr(r) {
  const l = {
    variables: {},
    light: {},
    dark: {}
  };
  return u(r.variables).forEach((a) => {
    C.variables[a] !== r.variables[a] && (l.variables[a] = r.variables[a]);
  }), u(r.light).forEach((a) => {
    C.light[a] !== r.light[a] && (l.light[a] = r.light[a]);
  }), u(r.dark).forEach((a) => {
    C.dark[a] !== r.dark[a] && (l.dark[a] = r.dark[a]);
  }), l;
}
function er(r) {
  return `
  ${r}[data-mantine-color-scheme="dark"] { --mantine-color-scheme: dark; }
  ${r}[data-mantine-color-scheme="light"] { --mantine-color-scheme: light; }
`;
}
function j({
  cssVariablesSelector: r,
  deduplicateCssVariables: l
}) {
  const a = V(), o = P(), i = K(), n = ir({ theme: a, generator: i }), s = r === ":root" && l, e = s ? sr(n) : n, t = ar(e, r);
  return t ? /* @__PURE__ */ F(
    "style",
    {
      "data-mantine-styles": !0,
      nonce: o == null ? void 0 : o(),
      dangerouslySetInnerHTML: {
        __html: `${t}${s ? "" : er(r)}`
      }
    }
  ) : null;
}
j.displayName = "@mantine/CssVariables";
function tr() {
  const r = console.error;
  console.error = (...l) => {
    l.length > 1 && typeof l[0] == "string" && l[0].toLowerCase().includes("extra attributes from the server") && typeof l[1] == "string" && l[1].toLowerCase().includes("data-mantine-color-scheme") || r(...l);
  };
}
function x(r, l) {
  var i, n;
  const a = typeof window != "undefined" && "matchMedia" in window && ((i = window.matchMedia("(prefers-color-scheme: dark)")) == null ? void 0 : i.matches), o = r !== "auto" ? r : a ? "dark" : "light";
  (n = l()) == null || n.setAttribute("data-mantine-color-scheme", o);
}
function cr({
  manager: r,
  defaultColorScheme: l,
  getRootElement: a,
  forceColorScheme: o
}) {
  const i = Z(null), [n, s] = rr(() => r.get(l)), e = o || n, t = B(
    (p) => {
      o || (x(p, a), s(p), r.set(p));
    },
    [r.set, e, o]
  ), $ = B(() => {
    s(l), x(l, a), r.clear();
  }, [r.clear, l]);
  return S(() => (r.subscribe(t), r.unsubscribe), [r.subscribe, r.unsubscribe]), h(() => {
    x(r.get(l), a);
  }, []), S(() => {
    var m;
    if (o)
      return x(o, a), () => {
      };
    o === void 0 && x(n, a), typeof window != "undefined" && "matchMedia" in window && (i.current = window.matchMedia("(prefers-color-scheme: dark)"));
    const p = (d) => {
      n === "auto" && x(d.matches ? "dark" : "light", a);
    };
    return (m = i.current) == null || m.addEventListener("change", p), () => {
      var d;
      return (d = i.current) == null ? void 0 : d.removeEventListener("change", p);
    };
  }, [n, o]), { colorScheme: e, setColorScheme: t, clearColorScheme: $ };
}
function pr({
  respectReducedMotion: r,
  getRootElement: l
}) {
  h(() => {
    var a;
    r && ((a = l()) == null || a.setAttribute("data-respect-reduced-motion", "true"));
  }, [r]);
}
tr();
function ur({
  theme: r,
  children: l,
  getStyleNonce: a,
  withStaticClasses: o = !0,
  withGlobalClasses: i = !0,
  deduplicateCssVariables: n = !0,
  withCssVariables: s = !0,
  cssVariablesSelector: e = ":root",
  classNamesPrefix: t = "mantine",
  colorSchemeManager: $ = or(),
  defaultColorScheme: p = "light",
  getRootElement: m = () => document.documentElement,
  cssVariablesResolver: d,
  forceColorScheme: z,
  stylesTransform: I,
  env: R
}) {
  const { colorScheme: W, setColorScheme: H, clearColorScheme: N } = cr({
    defaultColorScheme: p,
    forceColorScheme: z,
    manager: $,
    getRootElement: m
  });
  return pr({
    respectReducedMotion: (r == null ? void 0 : r.respectReducedMotion) || !1,
    getRootElement: m
  }), /* @__PURE__ */ F(
    Q.Provider,
    {
      value: {
        colorScheme: W,
        setColorScheme: H,
        clearColorScheme: N,
        getRootElement: m,
        classNamesPrefix: t,
        getStyleNonce: a,
        cssVariablesResolver: d,
        cssVariablesSelector: e,
        withStaticClasses: o,
        stylesTransform: I,
        env: R
      },
      children: /* @__PURE__ */ q(X, { theme: r, children: [
        s && /* @__PURE__ */ F(
          j,
          {
            cssVariablesSelector: e,
            deduplicateCssVariables: n
          }
        ),
        i && /* @__PURE__ */ F(lr, {}),
        l
      ] })
    }
  );
}
ur.displayName = "@mantine/core/MantineProvider";
const mr = [
  "#FBFAFE",
  "#EBEAFD",
  "#D9D8FC",
  "#BDB8FA",
  "#9B8FF6",
  "#7259EF",
  "#6149D6",
  "#503ABD",
  "#3E2AA3",
  "#2F1980"
], yr = {
  colors: {
    violet: [
      "#FBFAFE",
      "#EBEAFD",
      "#D9D8FC",
      "#BDB8FA",
      "#9B8FF6",
      "#7259EF",
      "#6149D6",
      "#503ABD",
      "#3E2AA3",
      "#2F1980"
    ],
    blue: [
      "#F5FAFF",
      "#E5F1FE",
      "#CDE4FD",
      "#AFD4FC",
      "#7EB9F8",
      "#4F96F4",
      "#417DD1",
      "#3666AE",
      "#2D528D",
      "#1F3A65"
    ],
    brass: [
      "#F7F7EF",
      "#E8E2D2",
      "#D3C8A7",
      "#BDAE80",
      "#BEA552",
      "#A88F4D",
      "#967D38",
      "#826D45",
      "#725F2D",
      "#514420"
    ],
    primary: mr,
    secondary: [
      "#F0E5F1",
      "#DBBFDF",
      "#C496CA",
      "#AB6EB4",
      "#8E57AB",
      "#8A3B93",
      "#7E378E",
      "#6E3085",
      "#5F2B7B",
      "#32004E"
    ],
    green: [
      "#F3FAF4",
      "#E3F5E6",
      "#C7EACC",
      "#A3D9AC",
      "#6CCF7D",
      "#31B457",
      "#249946",
      "#1C7A38",
      "#165F2B",
      "#0E3F1E"
    ],
    orange: [
      "#FFF8F3",
      "#FFEDE0",
      "#FFD6B8",
      "#FFBF8F",
      "#FF9E5D",
      "#F86816",
      "#D56226",
      "#B34E1E",
      "#8C3E17",
      "#632A0E"
    ],
    red: [
      "#FFF5F5",
      "#FEE7E8",
      "#FCC6C8",
      "#F89C9E",
      "#F46A6C",
      "#E04345",
      "#C03539",
      "#A02B2E",
      "#802223",
      "#5A1718"
    ],
    gray: [
      "#FAFBFC",
      "#F1F3F5",
      "#E9ECEF",
      "#DEE2E6",
      "#CED4DA",
      "#ADB5BD",
      "#868E96",
      "#495057",
      "#343A40",
      "#212529"
    ],
    republican: [
      "#FFF5F5",
      "#FFE0E0",
      "#FFC5C5",
      "#FFA8A8",
      "#FF8787",
      "#E0201E",
      // Main color
      "#C71F1C",
      "#AD1D1B",
      "#941B19",
      "#7A1917"
    ],
    democrat: [
      "#F5F8FF",
      "#E0EAFF",
      "#C5D9FF",
      "#A8C5FF",
      "#87AEFF",
      "#0044CC",
      // Main color
      "#003DB8",
      "#0036A3",
      "#002E8F",
      "#00277A"
    ]
  },
  headings: {
    fontWeight: "500"
  },
  spacing: {
    xxs: "0.25rem",
    xs: "0.5rem",
    sm: "0.75rem",
    md: "1rem",
    lg: "1.25rem",
    xl: "1.5rem",
    xxl: "2rem",
    "3xl": "2.5rem",
    "4xl": "3rem"
  },
  fontFamily: "Roboto, Arial, sans-serif",
  fontSizes: {
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.25rem",
    xl: "1.5rem"
  },
  activeClassName: "",
  defaultRadius: "0.25rem",
  primaryColor: "violet",
  shadows: {
    xs: "0px 2px 4px -2px rgba(0, 0, 0, 0.12)",
    sm: "0px 4px 8px -4px rgba(0, 0, 0, 0.16)",
    md: "0px 4px 12px -4px rgba(0, 0, 0, 0.20)",
    lg: "0px 8px 24px -8px rgba(0, 0, 0, 0.20)",
    xl: "0px 12px 40px -12px rgba(0, 0, 0, 0.20)"
  }
}, Er = (r) => ({
  variables: {
    // Add plum font family variables
    "--plum-font-family": "Roboto, Arial, sans-serif",
    // Add plum font size / line height variables
    "--plum-font-xs": "0.75rem",
    "--plum-font-sm": "0.875rem",
    "--plum-font-md": "1rem",
    "--plum-font-lg": "1.25rem",
    "--plum-font-xl": "1.5rem",
    "--plum-font-xxl": c("28px"),
    "--plum-font-3xl": c("32px"),
    "--plum-font-4xl": c("36px"),
    "--plum-font-5xl": c("40px"),
    "--plum-font-6xl": c("44px"),
    // Add plum letter spacing variables
    "--plum-letter-spacing-zero": "0",
    "--plum-letter-spacing-xxs": c("0.1px"),
    "--plum-letter-spacing-xs": c("0.25px"),
    "--plum-letter-spacing-sm": c("0.3px"),
    "--plum-letter-spacing-md": c("0.4px"),
    "--plum-letter-spacing-lg": c("0.5px"),
    "--plum-letter-spacing-xl": c("0.8px"),
    "--plum-letter-spacing-xxl": c("1px"),
    "--plum-letter-spacing-3xl": c("1.2px"),
    // Add plum spacing variables
    "--plum-spacing-zero": "0",
    "--plum-spacing-xxs": "0.25rem",
    "--plum-spacing-xs": "0.5rem",
    "--plum-spacing-sm": "0.75rem",
    "--plum-spacing-md": "1rem",
    "--plum-spacing-lg": "1.25rem",
    "--plum-spacing-xl": "1.5rem",
    "--plum-spacing-xxl": "2rem",
    "--plum-spacing-3xl": "2.5rem",
    "--plum-spacing-4xl": "3rem",
    // Add plum border radius variables
    "--plum-radius-zero": "0",
    "--plum-radius-xxs": "0.25rem",
    "--plum-radius-xs": "0.5rem",
    "--plum-radius-sm": "0.75rem",
    "--plum-radius-md": "1rem",
    "--plum-radius-lg": "1.25rem",
    "--plum-radius-xl": "1.5rem",
    "--plum-radius-xxl": "2rem",
    // Add new plum color variables while keeping mantine ones
    "--plum-violet-0": r.colors.violet[0],
    "--plum-violet-1": r.colors.violet[1],
    "--plum-violet-2": r.colors.violet[2],
    "--plum-violet-3": r.colors.violet[3],
    "--plum-violet-4": r.colors.violet[4],
    "--plum-violet-5": r.colors.violet[5],
    "--plum-violet-6": r.colors.violet[6],
    "--plum-violet-7": r.colors.violet[7],
    "--plum-violet-8": r.colors.violet[8],
    "--plum-violet-9": r.colors.violet[9],
    "--plum-brass-0": r.colors.brass[0],
    "--plum-brass-1": r.colors.brass[1],
    "--plum-brass-2": r.colors.brass[2],
    "--plum-brass-3": r.colors.brass[3],
    "--plum-brass-4": r.colors.brass[4],
    "--plum-brass-5": r.colors.brass[5],
    "--plum-brass-6": r.colors.brass[6],
    "--plum-brass-7": r.colors.brass[7],
    "--plum-brass-8": r.colors.brass[8],
    "--plum-brass-9": r.colors.brass[9],
    "--plum-gray-0": r.colors.gray[0],
    "--plum-gray-1": r.colors.gray[1],
    "--plum-gray-2": r.colors.gray[2],
    "--plum-gray-3": r.colors.gray[3],
    "--plum-gray-4": r.colors.gray[4],
    "--plum-gray-5": r.colors.gray[5],
    "--plum-gray-6": r.colors.gray[6],
    "--plum-gray-7": r.colors.gray[7],
    "--plum-gray-8": r.colors.gray[8],
    "--plum-gray-9": r.colors.gray[9],
    "--plum-green-0": r.colors.green[0],
    "--plum-green-1": r.colors.green[1],
    "--plum-green-2": r.colors.green[2],
    "--plum-green-3": r.colors.green[3],
    "--plum-green-4": r.colors.green[4],
    "--plum-green-5": r.colors.green[5],
    "--plum-green-6": r.colors.green[6],
    "--plum-green-7": r.colors.green[7],
    "--plum-green-8": r.colors.green[8],
    "--plum-green-9": r.colors.green[9],
    "--plum-red-0": r.colors.red[0],
    "--plum-red-1": r.colors.red[1],
    "--plum-red-2": r.colors.red[2],
    "--plum-red-3": r.colors.red[3],
    "--plum-red-4": r.colors.red[4],
    "--plum-red-5": r.colors.red[5],
    "--plum-red-6": r.colors.red[6],
    "--plum-red-7": r.colors.red[7],
    "--plum-red-8": r.colors.red[8],
    "--plum-red-9": r.colors.red[9],
    "--plum-orange-0": r.colors.orange[0],
    "--plum-orange-1": r.colors.orange[1],
    "--plum-orange-2": r.colors.orange[2],
    "--plum-orange-3": r.colors.orange[3],
    "--plum-orange-4": r.colors.orange[4],
    "--plum-orange-5": r.colors.orange[5],
    "--plum-orange-6": r.colors.orange[6],
    "--plum-orange-7": r.colors.orange[7],
    "--plum-orange-8": r.colors.orange[8],
    "--plum-orange-9": r.colors.orange[9],
    "--plum-blue-0": r.colors.blue[0],
    "--plum-blue-1": r.colors.blue[1],
    "--plum-blue-2": r.colors.blue[2],
    "--plum-blue-3": r.colors.blue[3],
    "--plum-blue-4": r.colors.blue[4],
    "--plum-blue-5": r.colors.blue[5],
    "--plum-blue-6": r.colors.blue[6],
    "--plum-blue-7": r.colors.blue[7],
    "--plum-blue-8": r.colors.blue[8],
    "--plum-blue-9": r.colors.blue[9],
    "--plum-democrat-0": r.colors.democrat[0],
    "--plum-democrat-1": r.colors.democrat[1],
    "--plum-democrat-2": r.colors.democrat[2],
    "--plum-democrat-3": r.colors.democrat[3],
    "--plum-democrat-4": r.colors.democrat[4],
    "--plum-democrat-5": r.colors.democrat[5],
    "--plum-democrat-6": r.colors.democrat[6],
    "--plum-democrat-7": r.colors.democrat[7],
    "--plum-democrat-8": r.colors.democrat[8],
    "--plum-democrat-9": r.colors.democrat[9],
    "--plum-republican-0": r.colors.republican[0],
    "--plum-republican-1": r.colors.republican[1],
    "--plum-republican-2": r.colors.republican[2],
    "--plum-republican-3": r.colors.republican[3],
    "--plum-republican-4": r.colors.republican[4],
    "--plum-republican-5": r.colors.republican[5],
    "--plum-republican-6": r.colors.republican[6],
    "--plum-republican-7": r.colors.republican[7],
    "--plum-republican-8": r.colors.republican[8],
    "--plum-republican-9": r.colors.republican[9],
    "--plum-white": "#FFFFFF",
    "--plum-black": "#000000",
    // Add plum shadow variables
    "--plum-shadow-xs": r.shadows.xs,
    "--plum-shadow-sm": r.shadows.sm,
    "--plum-shadow-md": r.shadows.md,
    "--plum-shadow-lg": r.shadows.lg,
    "--plum-shadow-xl": r.shadows.xl
  },
  light: {
    "--mantine-color-error": "var(--plum-red-7)"
  },
  dark: {}
});
export {
  El as ActionBar,
  Ar as Alert,
  kr as Avatar,
  Sr as Badge,
  Tr as Breadcrumbs,
  Pr as Button,
  Lr as Card,
  zr as Checkbox,
  Rr as Collapse,
  Hr as ColorPicker,
  _r as DatePicker,
  Gr as Dialog,
  Kr as DismissibleTag,
  Ur as Divider,
  Xr as DraggableList,
  Zr as Drawer,
  ml as ErrorMessage,
  oo as FileDropzone,
  Dl as Flex,
  Vl as Grid,
  Bl as Group,
  $l as HeadingActions,
  ao as Highlight,
  tl as InlineSelect,
  io as Label,
  eo as Link,
  co as Menu,
  uo as Modal,
  go as MultiSelect,
  xo as Notification,
  pl as PageNavigation,
  Fo as Pagination,
  ur as PlumProvider,
  $o as ProgressIndicator,
  Eo as Radio,
  wo as RichText,
  Do as SearchBar,
  gl as SearchPopdown,
  Bo as SegmentedControl,
  Vo as Select,
  ho as SelectableTag,
  xl as Sidebar,
  jo as Skeleton,
  Mo as Slider,
  Ml as Stack,
  Io as Stepper,
  Wo as Switch,
  No as Table,
  Oo as Tabs,
  sl as TagsInput,
  wl as Text,
  qo as TextField,
  Jo as Tile,
  rl as TimePicker,
  Yo as Timeline,
  Qo as Title,
  ll as Toggletip,
  nl as Tooltip,
  Fl as TopNav,
  yr as plumTheme,
  Er as plumVariables
};
